<div [class.is-empty]="!data.title" matDialogTitle>
  @if (data.title) {
    <div [innerHtml]="data.title | bypassSecurity"></div>
  }
  <button mat-dialog-close="cancel">
    <ui-icon faName="xmark" faStyle="light"></ui-icon>
  </button>
</div>

@if (data.content) {
  <mat-dialog-content [class.no-padding]="!data.title" class="mat-typography" matDialogContent>
    <div [innerHtml]="data.content | bypassSecurity"></div>
  </mat-dialog-content>
}

@if (data.acceptLabel || data.cancelLabel) {
  <mat-dialog-actions align="end">
    @if (data.cancelLabel) {
      <ui-button mat-dialog-close="cancel" buttonStyle="text">{{ data.cancelLabel }}</ui-button>
    }
    @if (data.acceptLabel) {
      <ui-button mat-dialog-close="accept" buttonStyle="filled">{{ data.acceptLabel }}</ui-button>
    }
  </mat-dialog-actions>
}
